import {
  LibraryItemsPowerBiHttpClient,
  ProjectHttpClient,
} from '../../common/services/httpClient';

export const getReports = async (projectId) => {
  try {
    const response = await LibraryItemsPowerBiHttpClient.get(
      `projects/${projectId}/powerBiReports`
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

export const getReportEmbedData = async (
  projectId,
  libraryItemId,
  isShared
) => {
  const shared = isShared || false;

  const response = await ProjectHttpClient.get(
    `projects/${projectId}/powerBiReports/search?libraryItemId=${libraryItemId}&shared=${shared}`
  );
  return response.data;
};

export const getReportEmbedDataByReportId = async (projectId, reportId) => {
  const response = await LibraryItemsPowerBiHttpClient.get(
    `projects/${projectId}/powerBiReports/${reportId}`
  );
  return response.data;
};

export const getReportDataByReportIdAsPng = async (projectId, reportId) => {
  const response = await LibraryItemsPowerBiHttpClient.get(
    `projects/${projectId}/powerBiReports/${reportId}/AsPng`
  );
  return response.data;
};

export const getPowerBiReportData = async (projectId, reportData) => {
  const response = await LibraryItemsPowerBiHttpClient.post(
    `/projects/${projectId}`,
    reportData
  );
  return response.data;
};
